import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

const EmptyRouterView = {
  template: '<router-view></router-view>'
}


export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: EmptyRouterView,
      meta: {
        requiresOpenIdAuth: true
      },
      children: [
        {
          path: '',
          alias: 'step/1',
          name: 'home',
          component: () => import(/* webpackChunkName: "home" */ './views/Home.vue')
        },
        {
          path: 'report',
          name: 'report',
          component: () => import(/* webpackChunkName: "report" */ './views/report.vue')
        },
        {
          path: 'step/:step',
          name: 'inspection',
          component: () => import(/* webpackChunkName: "home" */ './views/Inspection.vue')
        }
      ]

    }
  ]
})
